/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
enum AssetTypes {
    '3DModel' = '3DModel',
    AutoCad = 'AutoCad',
    BIM = 'BIM',
    DerivedImage = 'DerivedImage',
    DerivedVideo = 'DerivedVideo',
    Document = 'Document',
    IfcModel = 'IfcModel',
    Image = 'Image',
    Image360 = 'Image360',
    ImageAnnotation = 'ImageAnnotation',
    ImageTif = 'ImageTif',
    Import = 'Import',
    MeasurementPDF = 'MeasurementPDF',
    MeasurementXLS = 'MeasurementXLS',
    PlyModel = 'PlyModel',
    Pointcloud = 'Pointcloud',
    SurveyVideo = 'SurveyVideo',
    TarArchive = 'TarArchive',
    Text = 'Text',
    Unknown = 'Unknown',
    Verification = 'Verification',
    Video = 'Video',
    Voice = 'Voice',
    ZipArchive = 'ZipArchive',
}

export { AssetTypes };
